export type SpinnerProps = { size?: "base" | "sm"; className?: string };

const SIZE_MAP = {
  base: "w-16",
  sm: "w-8",
} satisfies Record<NonNullable<SpinnerProps["size"]>, string>;

export function Spinner({ size, className }: SpinnerProps) {
  return (
    <div
      className={[
        "flex w-screen h-screen justify-center items-center pointer-events-none",
        className,
      ].join(" ")}
    >
      <div
        className={`inline-block ${SIZE_MAP[size ?? "base"]} aspect-square animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-antique-brass-500 motion-reduce:animate-[spin_1.5s_linear_infinite]`}
        role="status"
      >
        <span
          className={
            "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
          }
        >
          Carregando...
        </span>
      </div>
    </div>
  );
}
